module.exports = global["jQuery"] = require("-!/opt/atlassian/pipelines/agent/build/arkanoid.web/node_modules/expose-loader/index.js?$!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/dist/jquery.js-exposed
// module id = 304
// module chunks = 2